export enum Role {
    THERAPIST = 2,
    OWNER = 1,
    PATIENT = 3,
    RECEPTIONIST = 5,
    OBSERVER = 4,
}
